import styled from "styled-components";

import backgroundImage from "../img/background.png";

export const FullscreenWrapper = styled("div")({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  overflow: "hidden"
});

export const MainContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  margin: auto;
  background-color: #f5f5f5;
  background-image: url(${backgroundImage});
  background-size: cover; 
  background-position: center;
  color: black;
`;

export const GuestCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GuestImage = styled.img`
  width: 60vw;
  height: 60vw; 
  max-width: 80%; 
  max-height: 80vh; 
  object-fit: contain; 
  margin-bottom: 60px;
`;

export const GuestName = styled.p`
  color: #fff;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Mark Offc For MC";
  font-size: 70px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;

export const WaitingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center; 
  gap: 20px;
`;

export const MdesLogo = styled.img`
  width: 250px; 
  height: 94px;
  object-fit: contain;
`;

export const MastercardLogo = styled.img`
  width: 204px; 
  height: 104px;
  object-fit: contain;
`;

export const WaitingText = styled.p`
  color: #afafaf;
  text-align: center;
  font-family: "Mark Offc For MC";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 10px;
  letter-spacing: 0.25px;
`;
